module.exports = __webpack_public_path__ + "static/img/loader.54c8d06.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = M7I8
// module chunks = 1